import { render } from "./search_new.vue?vue&type=template&id=0d10a94c&scoped=true"
import script from "./search_new.vue?vue&type=script&lang=js"
export * from "./search_new.vue?vue&type=script&lang=js"

import "./search_new.vue?vue&type=style&index=0&id=0d10a94c&lang=scss"
import "./search_new.vue?vue&type=style&index=1&id=0d10a94c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d10a94c"]])

export default __exports__